export default __webpack_public_path__ + "static/media/r6e_logo_zh-TW.e1798cbc.png";